"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var ethFuncs = _interopRequireWildcard(require("./ethereum/ethFuncs"));
var memo = _interopRequireWildcard(require("./memo"));
var qr = _interopRequireWildcard(require("./qr"));
var _blockies = _interopRequireDefault(require("./blockies"));
var _myetherwallet = _interopRequireDefault(require("./ethereum/myetherwallet"));
var _http = _interopRequireDefault(require("./rest/http"));
var _endpoint = _interopRequireDefault(require("./rest/endpoint"));
var _ajaxReq = _interopRequireDefault(require("./rest/ajaxReq"));
var _connection = _interopRequireDefault(require("./connection"));
var _customization = _interopRequireDefault(require("./customization"));
var _wallet = _interopRequireDefault(require("./wallet"));
var _bcRead = _interopRequireDefault(require("./bcRead"));
var _bcTransaction = require("./bcTransaction");
var _transactions = _interopRequireDefault(require("./config/transactions"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function createIcon(address) {
  if (address instanceof _myetherwallet["default"]) {
    address = address.getAddressString();
  }
  return (0, _blockies["default"])({
    seed: address.toLowerCase(),
    size: 8,
    scale: 16
  }).toDataURL();
}
var AbstractJsc3l = /*#__PURE__*/function () {
  function AbstractJsc3l(localDefaultConf, defaultTransactionDefs) {
    (0, _classCallCheck2["default"])(this, AbstractJsc3l);
    this._currencyMgrPromises = {};
    this.localDefaultConf = localDefaultConf || {};
    this.defaultTransactionDefs = defaultTransactionDefs || _transactions["default"];
  }
  /**
   * `connection` facility needs to be lazy loaded as `this` and
   * abstract `httpRequest` is not available in constructor.
   */
  (0, _createClass2["default"])(AbstractJsc3l, [{
    key: "connection",
    get: function get() {
      if (!this._connection) {
        var self = this;
        var ConnectionMgr = /*#__PURE__*/function (_ConnectionMgrAbstrac) {
          (0, _inherits2["default"])(ConnectionMgr, _ConnectionMgrAbstrac);
          var _super = _createSuper(ConnectionMgr);
          function ConnectionMgr() {
            var _this;
            (0, _classCallCheck2["default"])(this, ConnectionMgr);
            _this = _super.apply(this, arguments);
            _this.http = self.http;
            _this.persistentStore = self.persistentStore;
            return _this;
          }
          return (0, _createClass2["default"])(ConnectionMgr);
        }(_connection["default"]);
        this._connection = new ConnectionMgr();
      }
      return this._connection;
    }
    /**
     * `Endpoint` class is a facility that needs to be lazy loaded as
     * `this` and abstract `httpRequest` is not available in
     * constructor.
     */
  }, {
    key: "Endpoint",
    get: function get() {
      if (!this._Endpoint) {
        var self = this;
        var Endpoint = /*#__PURE__*/function (_EndpointAbstract) {
          (0, _inherits2["default"])(Endpoint, _EndpointAbstract);
          var _super2 = _createSuper(Endpoint);
          function Endpoint() {
            var _this2;
            (0, _classCallCheck2["default"])(this, Endpoint);
            _this2 = _super2.apply(this, arguments);
            _this2.httpRequest = self.httpRequest;
            return _this2;
          }
          return (0, _createClass2["default"])(Endpoint);
        }(_endpoint["default"]);
        this._Endpoint = Endpoint;
      }
      return this._Endpoint;
    }
    /**
     * 'http' facility needs to be lazy loaded as 'this' and abstract
     * httpRequest is not available in constructor.
     */
  }, {
    key: "http",
    get: function get() {
      if (!this._http) {
        var self = this;
        // ConnectionMgr
        var Http = /*#__PURE__*/function (_HttpAbstract) {
          (0, _inherits2["default"])(Http, _HttpAbstract);
          var _super3 = _createSuper(Http);
          function Http() {
            var _this3;
            (0, _classCallCheck2["default"])(this, Http);
            _this3 = _super3.apply(this, arguments);
            _this3.httpRequest = self.httpRequest;
            return _this3;
          }
          return (0, _createClass2["default"])(Http);
        }(_http["default"]);
        this._http = new Http();
      }
      return this._http;
    }
  }, {
    key: "getAjaxReq",
    value: function getAjaxReq(endpointUrl) {
      var self = this;
      var AjaxReq = /*#__PURE__*/function (_AjaxReqAbstract) {
        (0, _inherits2["default"])(AjaxReq, _AjaxReqAbstract);
        var _super4 = _createSuper(AjaxReq);
        function AjaxReq() {
          var _this4;
          (0, _classCallCheck2["default"])(this, AjaxReq);
          _this4 = _super4.apply(this, arguments);
          _this4.endpoint = new self.Endpoint(endpointUrl);
          return _this4;
        }
        return (0, _createClass2["default"])(AjaxReq);
      }(_ajaxReq["default"]);
      return new AjaxReq();
    }
    /**
     * `getConfJson` check persistent storage for configuration for
     * given currency, otherwise will use the given repo to fetch
     * it (and save it in persistent storage).
     */
  }, {
    key: "getConfig",
    value: function () {
      var _getConfig = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(repo, currencyName) {
        var _a, cfgJson;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              cfgJson = this.connection.getLocalConfJSON();
              if (!(cfgJson && ((_a = cfgJson.server) === null || _a === void 0 ? void 0 : _a.name) === currencyName)) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return", cfgJson);
            case 3:
              _context.next = 5;
              return this.connection.getConfJSON(currencyName, repo);
            case 5:
              return _context.abrupt("return", _context.sent);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getConfig(_x, _x2) {
        return _getConfig.apply(this, arguments);
      }
      return getConfig;
    }()
    /**
     * `getConfJson` check persistent storage for configuration for
     * given currency, otherwise will use the given repo to fetch
     * it (and save it in persistent storage).
     */
  }, {
    key: "getCustomization",
    value: function getCustomization(config) {
      var Customization = /*#__PURE__*/function (_CustomizationAbstrac) {
        (0, _inherits2["default"])(Customization, _CustomizationAbstrac);
        var _super5 = _createSuper(Customization);
        function Customization() {
          var _this5;
          (0, _classCallCheck2["default"])(this, Customization);
          _this5 = _super5.apply(this, arguments);
          _this5.cfg = config;
          return _this5;
        }
        return (0, _createClass2["default"])(Customization);
      }(_customization["default"]);
      return new Customization(this.localDefaultConf);
    }
  }, {
    key: "getWallet",
    value: function getWallet(endpointUrl, currencyName, unlockUrl) {
      var self = this;
      var MessagingWallet = /*#__PURE__*/function (_MessagingWalletAbstr) {
        (0, _inherits2["default"])(MessagingWallet, _MessagingWalletAbstr);
        var _super6 = _createSuper(MessagingWallet);
        function MessagingWallet() {
          var _this6;
          (0, _classCallCheck2["default"])(this, MessagingWallet);
          _this6 = _super6.apply(this, arguments);
          _this6.ajaxReq = self.getAjaxReq(endpointUrl);
          _this6.currencyName = currencyName;
          _this6.unlockUrl = unlockUrl;
          return _this6;
        }
        return (0, _createClass2["default"])(MessagingWallet);
      }(_wallet["default"]); // XXXvlab: should we instanciate this ?
      return MessagingWallet;
    }
  }, {
    key: "getBcRead",
    value: function getBcRead(endpointUrl, contracts) {
      var self = this;
      var BcRead = /*#__PURE__*/function (_BcReadAbstract) {
        (0, _inherits2["default"])(BcRead, _BcReadAbstract);
        var _super7 = _createSuper(BcRead);
        function BcRead() {
          var _this7;
          (0, _classCallCheck2["default"])(this, BcRead);
          _this7 = _super7.apply(this, arguments);
          _this7.ajaxReq = self.getAjaxReq(endpointUrl);
          _this7.contracts = contracts;
          return _this7;
        }
        return (0, _createClass2["default"])(BcRead);
      }(_bcRead["default"]);
      return new BcRead();
    }
  }, {
    key: "getBcTransaction",
    value: function getBcTransaction(endpointUrl, contracts, transactionDefs) {
      var self = this;
      var BcTransaction = /*#__PURE__*/function (_BcTransactionAbstrac) {
        (0, _inherits2["default"])(BcTransaction, _BcTransactionAbstrac);
        var _super8 = _createSuper(BcTransaction);
        function BcTransaction() {
          var _this8;
          (0, _classCallCheck2["default"])(this, BcTransaction);
          _this8 = _super8.apply(this, arguments);
          _this8.ajaxReq = self.getAjaxReq(endpointUrl);
          _this8.contracts = contracts;
          return _this8;
        }
        return (0, _createClass2["default"])(BcTransaction);
      }(_bcTransaction.BcTransactionAbstract);
      (0, _bcTransaction.transactionFactory)(transactionDefs, BcTransaction);
      return new BcTransaction();
    }
  }, {
    key: "getCurrencyMgr",
    value: function () {
      var _getCurrencyMgr2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(currencyName, endpointUrl, repoUrl, transactionDefs) {
        var key,
          _args2 = arguments;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              key = JSON.stringify(Array.from(_args2));
              if (!this._currencyMgrPromises[key]) {
                this._currencyMgrPromises[key] = this._getCurrencyMgr(currencyName, endpointUrl, repoUrl, transactionDefs);
              }
              _context2.next = 4;
              return this._currencyMgrPromises[key];
            case 4:
              return _context2.abrupt("return", _context2.sent);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getCurrencyMgr(_x3, _x4, _x5, _x6) {
        return _getCurrencyMgr2.apply(this, arguments);
      }
      return getCurrencyMgr;
    }()
  }, {
    key: "_getCurrencyMgr",
    value: function () {
      var _getCurrencyMgr3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(currencyName, endpointUrl, repoUrl, transactionDefs) {
        var config, customization, contracts, wallet;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (repoUrl) {
                _context3.next = 8;
                break;
              }
              if (!this.connection.repo) {
                _context3.next = 5;
                break;
              }
              repoUrl = this.connection.repo;
              _context3.next = 8;
              break;
            case 5:
              _context3.next = 7;
              return this.connection.lookupAvailableComChainRepo();
            case 7:
              repoUrl = _context3.sent;
            case 8:
              if (endpointUrl) {
                _context3.next = 16;
                break;
              }
              if (!this.connection.endpoint) {
                _context3.next = 13;
                break;
              }
              endpointUrl = this.connection.endpoint;
              _context3.next = 16;
              break;
            case 13:
              _context3.next = 15;
              return this.connection.acquireEndPoint(repoUrl);
            case 15:
              endpointUrl = _context3.sent.endpoint;
            case 16:
              transactionDefs = transactionDefs || _transactions["default"];
              _context3.next = 19;
              return this.getConfig(repoUrl, currencyName);
            case 19:
              config = _context3.sent;
              customization = this.getCustomization(config);
              contracts = [customization.getContract1(), customization.getContract2(), customization.getContract3()];
              wallet = this.getWallet(endpointUrl, currencyName, customization.getUnlockUrl());
              return _context3.abrupt("return", {
                // unlockWallet: (jsonData, password) => wallet.getWalletFromPrivKeyFile(jsonData, password),
                jsc3l: this,
                customization: customization,
                ajaxReq: this.getAjaxReq(endpointUrl),
                wallet: wallet,
                bcRead: this.getBcRead(endpointUrl, contracts),
                bcTransaction: this.getBcTransaction(endpointUrl, contracts, transactionDefs)
              });
            case 24:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function _getCurrencyMgr(_x7, _x8, _x9, _x10) {
        return _getCurrencyMgr3.apply(this, arguments);
      }
      return _getCurrencyMgr;
    }()
  }]);
  return AbstractJsc3l;
}();
Object.assign(AbstractJsc3l.prototype, {
  memo: memo,
  ethFuncs: ethFuncs,
  createIcon: createIcon,
  qr: qr
});
var IntegratedJsc3lAbstract = /*#__PURE__*/function (_AbstractJsc3l) {
  (0, _inherits2["default"])(IntegratedJsc3lAbstract, _AbstractJsc3l);
  var _super9 = _createSuper(IntegratedJsc3lAbstract);
  function IntegratedJsc3lAbstract() {
    (0, _classCallCheck2["default"])(this, IntegratedJsc3lAbstract);
    return _super9.apply(this, arguments);
  }
  (0, _createClass2["default"])(IntegratedJsc3lAbstract, [{
    key: "ajaxReq",
    get:
    /**
     * `ajaxReq` depends on a loaded endpoint in
     * `this.connection.endpoint` obtained through
     * `this.endpoint.acquireEndPoint(..)`.  XXXvlab: We could cache the
     * result with endpoint being a key.
     */
    function get() {
      if (!this.connection.endpoint) {
        throw new Error('An endpoint need to have been acquired.');
      }
      return this.getAjaxReq(this.connection.endpoint);
    }
    /**
     * `customization` depends on a local configuration being available
     * through a previous call to
     * `this.connection.getConfJSON(..)`. Although as it has some
     * fallback available, we need to be able to support being called
     * even if no local conf is loaded yet.
     *
     * XXXvlab: We could cache the result with result of
     * `connection.getLocalConf()` being the key.
     */
  }, {
    key: "customization",
    get: function get() {
      // XXXvlab: Probably don't need a module for that, as the configuration
      // is always re-queried and quite small, we could cache-it in memory.
      var localCfg = this.connection.getLocalConfJSON();
      if (!localCfg) {
        console.log('No local configuration available yet.');
        localCfg = {};
      }
      return this.getCustomization(localCfg);
    }
    /**
     * `wallet` depends on both:
     * - a local configuration (only for the `currencyName`) being
     *   available through a previous call to
     *   `this.connection.getConfJSON(..)`
     * - a loaded endpoint in `this.connection.endpoint` obtained
     *   through `this.endpoint.acquireEndPoint(..)`.
     *
     * XXXvlab: We could cache the result with result of
     * `connection.getLocalConf()` and `this.connection.endpoint` being
     * the keys.
     */
  }, {
    key: "wallet",
    get: function get() {
      if (!this.ajaxReq) {
        throw new Error('a connect() is required before accessing wallet');
      }
      var localCfg;
      try {
        localCfg = this.customization;
      } catch (e) {
        throw new Error('A local conf needs to be available before accessing wallet');
      }
      return this.getWallet(this.ajaxReq.endpoint.baseUrl, localCfg.getCurrencyName(), this.customization.getUnlockUrl());
    }
    /**
     * `bcRead` access depends on both:
     * - a local configuration (only for contracts information) being
     *   available through a previous call to
     *   `this.connection.getConfJSON(..)`
     * - a loaded endpoint in `this.connection.endpoint` obtained through
     *   `this.endpoint.acquireEndPoint(..)`.
     *
     * XXXvlab: We could cache the result with result of
     * `connection.getLocalConf()` and `this.connection.endpoint` being
     * the keys.
     */
  }, {
    key: "bcRead",
    get: function get() {
      if (!this.ajaxReq) {
        throw new Error('an init() is required before accessing bcRead');
      }
      var localCfg;
      try {
        localCfg = this.customization;
      } catch (e) {
        throw new Error('A local conf needs to be available before accessing wallet');
      }
      return this.getBcRead(this.ajaxReq.endpoint.baseUrl, [localCfg.getContract1(), localCfg.getContract2()]);
    }
    /**
     * `bcTransaction` access depends on both:
     * - a local configuration (only for contracts information) being
     *   available through a previous call to
     *   `this.connection.getConfJSON(..)`
     * - a loaded endpoint in `this.connection.endpoint` obtained through
     *   `this.endpoint.acquireEndPoint(..)`.
     *
     * XXXvlab: We could cache the result with result of
     * `connection.getLocalConf()` and `this.connection.endpoint` being
     * the keys.
     */
  }, {
    key: "bcTransaction",
    get: function get() {
      if (!this.ajaxReq) {
        throw new Error('an init() is required before accessing bcTransaction');
      }
      var localCfg;
      try {
        localCfg = this.customization;
      } catch (e) {
        throw new Error('A local conf needs to be available before accessing wallet');
      }
      return this.getBcTransaction(this.ajaxReq.endpoint.baseUrl, [localCfg.getContract1(), localCfg.getContract2(), localCfg.getContract3()], this.defaultTransactionDefs);
    }
  }]);
  return IntegratedJsc3lAbstract;
}(AbstractJsc3l);
var _default = IntegratedJsc3lAbstract;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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